import e from"./config.js";import r from"./utils/defer.js";import{buildQuery as o}from"./utils/url.js";var i=r(),n=!1,t=!1,a=i.promise;export default function(){if(!t){if(t=!0,window.AMap)return i.resolve(window.AMap),a;var r=document.createElement("script"),p="amap_vue_"+Date.now()+"_"+Math.ceil(1e4*Math.random());window[p]=function(){n||(n=!0,i.resolve(window.AMap))};var l=o({v:e.version,key:e.key,callback:p,plugin:e.plugins.join(",")}),u=e._prefix+"?"+l;r.src=u,document.body.appendChild(r)}return a}export{a as ready};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@amap/amap-vue/es/load-amap.js
// module id = null
// module chunks = 